import script from "./ProfileInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileInfo.vue?vue&type=script&setup=true&lang=js"

import "./ProfileInfo.vue?vue&type=style&index=0&id=57a44e6a&scoped=true&lang=css"

import exportComponent from "../../../consumer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a44e6a"]])

export default __exports__